'use strict';

var StrategyActionDirective = function StrategyActionDirective(angularHelper) {
  return {
    restrict: 'E',
    template: require('../templates/strategy-action.html'),
    controller: 'StrategyActionController',
    scope: {
      action: '=',
      allActions: '=',
      changeSelectedRow: '=',
      activeEntityType: '=',
      level: '='
    },
    link: function link($scope, element) {
      element.find('div.row').focusin(function () {
        $scope.changeSelectedRow($scope.action, 'actions');
        angularHelper.triggerApply($scope);
      });
    }
  };
};
StrategyActionDirective.$inject = ['AngularHelper'];
module.exports = StrategyActionDirective;